module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-spend-03-f689a122fedba32faf5722983f16259d.png";